<template>
    <div v-cloak class="transfer-right-body" id="remoteTask" element-loading-background="rgba(0, 0, 0, 0.05)">
        <div class="task-top">
            <div class="task-top-position">
                <div class="transfer-name">{{$t('language.common.btLink')}}</div>
                <div class="transfer-description">{{$t('language.remoteTask.createDescribe')}}</div>
            </div>
        </div>
        <div class="task-middle">
            <div class="task-box-position">
                <div class="task-box" :class="boxFrom">
                    <el-scrollbar style="height:100%;">
                        <div class="task-operating" v-if="sourceItems.length<1">
                            <div class="task-operating-name">{{$t('language.cloudTransfer.from')}}</div>
                            <div class="box-center-btn" @click="linkTaskOpen()">
                                <div class="icon-18-link"></div>{{$t('language.remoteTask.addLink')}}
                            </div>
                            <div class="box-center-btn" @click="addTorrent()">
                                <div class="icon-18-upload"></div>{{$t('language.popup.remoteTaskPopup.addTorrent')}}
                                <input type="file" hidden="hidden" id="torrent" accept=".torrent" @change="torrentShow()" />
                            </div>
                        </div>
                        <div class="task-main" v-if="sourceItems.length==1">
                            <div class="icon-del" style="top:-40%;right:-8%;position: absolute;" @click.stop="removeItem(0)"></div>
                            <div class="task-type large-file-type" v-bind:class="'large-' + matchfileType(sourceItems[0].name)"></div>
                            <div class="task-catalog" :title="sourceItems[0].name">{{ sourceItems[0].name }}</div>
                        </div>
                        <div class="task-source-more" v-if="sourceItems.length>1">
                            <div class="task-source-title">
                                {{$t('language.common.name')}}
                                <div class="delete-btn" @click.stop="removeAll()">
                                    <div class="icon-util delete"></div>
                                    {{$t('language.cloudExploer.deleteAll')}}
                                </div>
                            </div>
                            <div class="source-item" :key="index" v-for="(item,index) in sourceItems">
                                <div class="item-formicon small-file" :class="matchfileType(item.name)+'-small'"></div>
                                <div class="item-url" :title="item.name">{{item.name}}</div>
                                <div class="icon-util round-cancel round-cancel-position" @click.stop="removeItem(index)"></div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
                <div class="task-box-middle">
                    <div class="arrow-position"></div>
                </div>
                <div class="task-box" :class="boxTo" @click="selectCloudOpen()">
                    <div class="task-operating" v-if="!singleDrives">
                        <div class="task-operating-name">{{$t('language.cloudTransfer.to')}}</div>
                        <div class="task-operating-des">{{$t('language.cloudTransfer.transferOperateTo') }}</div>
                    </div>
                    <div class="task-main" v-else>
                        <div class="task-type task-icon" v-bind:class="singleDrives.cloudType + '_big'"></div>
                        <div class="task-catalog" :title="singleDrives.cloudCatalog">{{ singleDrives.cloudCatalog }}</div>
                    </div>
                </div>
            </div>
            <div class="definite-operating">
                <div style="position:relative;margin-left: -2.3%;">
                    <!-- <div class="operating-schedule">
                        <div class="icon-util" @click.stop="checkedOpen()" :class="checkedEmail?'check':'nocheck'" style="float:left;"></div>
                        <div class="operating-position" @click.stop="openAddEmailNotice()">{{$t('language.remoteTask.startEmailSend')}}</div>
                    </div> -->
                    <!-- <edit-input ref="editInput" :inputValue=inputValue :submitTaskName="submiTransfertName"></edit-input> -->
                    <button class="transfer-button" v-loading="btnLoading" @click="transferNow()">
                        <div class="icon transfer-icon-position linkTask"></div>
                        <div style="float:left;">{{$t('language.remoteTask.nowUpload')}}</div>
                    </button>
                    <transition name="flow">
                        <div class="flow-icon" v-show="flowShow" id="remoteFlow">
                            <div class="icon transfer-icon-position linkTask flow-icon-position"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="task-buttom"></div>

        <!-- 种子文件选择弹窗 -->
        <parseTipsDialog ref="parseTipsDialog"></parseTipsDialog>

        <linkTaskDialog ref="linkTaskDialog"></linkTaskDialog>
        <subfileSelectDialog ref="subfileSelectDialog"></subfileSelectDialog>
        <addEmialNoticeDialog ref="addEmialNoticeDialog"></addEmialNoticeDialog>
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
        <uploadToTreeDialog ref="uploadToTreeDialog"></uploadToTreeDialog>
    </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import remoteTaskUtils from "@/js/workspace/remote_task_util.js";
import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
import taskListUtils from "@/js/workspace/task_list_util.js";
import parseTipsDialog from '@/components/popup/remote_task_popups/parse_tips';
import linkTaskDialog from '@/components/popup/remote_task_popups/add_link_task_popup';
import subfileSelectDialog from '@/components/popup/remote_task_popups/subfile_select_popup.vue';
import addEmialNoticeDialog from '@/components/popup/remote_task_popups/add_email_notice_popup';
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import uploadToTreeDialog from '@/components/popup/remote_task_popups/upload_to_tree_popup';
import editInput from '@/components/common/input/edit_input';
export default {
    data: function() {
        return {
            remoteType: 0,//当前离线下载类型：0无，1weburl，2BT，3Torrent
            inputValue: commonUtils.getTaskTxt(this),//默认任务名
            sourceItems: [],//源信息集合
            singleDrives: null,//目标云盘
            hoverCurrent: -1,//选中效果
            checkedEmail: false,
            sendEmail: "",//发送的邮箱
            boxFrom: '',//窗口样式抖动
            boxTo: '',//窗口样式抖动
            btnLoading: false,
            torrentType: '',//种子类型
            torrentId: '',//种子id
            flowShow: false,
        }
    },
    components: {
        parseTipsDialog,
        linkTaskDialog,
        subfileSelectDialog,
        addEmialNoticeDialog,
        upgradeNewDialog,
        uploadToTreeDialog,
        "edit-input": editInput,
    },
    created() {
        remoteTaskUtils.init(this);
    },
    mounted() {
        //初始化界面名称
        commonUtils.initPageName(this,'remoteTask');
    },
    methods: {
        //匹配文件类型
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        linkTaskOpen() {
            if (!this.$refs.parseTipsDialog.parseTipsShow) {
                this.$refs.linkTaskDialog.linkTaskShow = true;
            }
        },
        //创建任务并立刻执行
        transferNow() {
            if(!this.sourceItems.length>0) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
                return;
            }
            if(!this.singleDrives) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
                return;
            }
            var that = this;
            let cloudSite = taskTransferUtils.createTransferToItems(this.singleDrives.toDrivesInfo);
            switch (this.remoteType) {
                case 1:
                    //判断是否是临时用户，然后提醒用户进行绑定邮箱
                    let user = commonUtils.getUser();
                    if (commonUtils.testUserIsTourist(user)) {
                        that.$refs.remindBindEmailDialog.remindBindEmailShow = true;
                        return false;
                    }
                    this.btnLoading = true;
                    remoteTaskUtils.submitOffLine(cloudSite,function(status) {
                        that.btnLoading = false;
                        if(status == 200) {
                            that.btnLoading = true;
                            remoteTaskUtils.doRequestIfWeb(that.inputValue,that.sourceItems[0].link,cloudSite,that.sendEmail,function(res) {
                                that.btnLoading = false;
                                console.log(res)
                                if(res.status == 200) {
                                    //创建任务成功
                                    taskListUtils.exeSuccessEnd('remoteFlow', 'taskList', res.tasks, that);
                                }
                            });
                        }
                    });
                    break;
                case 2:
                    if(cloudSite.length>0) {
                        cloudSite = cloudSite[0];
                    }
                    this.btnLoading = true;
                    remoteTaskUtils.torrentDownload(this.inputValue,this.torrentId,this.torrentType,this.sourceItems,cloudSite,this.sendEmail,function(res) {
                        that.btnLoading = false;
                        if(res.status == 200) {
                            //创建任务成功
                            taskListUtils.exeSuccessEnd('remoteFlow', 'taskList', res.tasks, that);
                        }
                    });
                    break;
                case 3:
                    this.btnLoading = true;
                    this.addTorrent();
                    this.btnLoading = false;
                    break;
                default:
                    this.boxFrom = "box-shake";
                    setTimeout(() => {
                        this.boxFrom = "box-shakeOrigin";
                    }, 100);
                    break;
            }
        },
        addTorrent() {
            document.getElementById("torrent").click();
        },
        initTorrent() {
            //初始化 为保证监听器生效，1和 2必须在textLink前执行
            this.remoteType = 0;
            this.torrentType = '';//种子类型
            this.torrentId = '';//种子id
            this.sourceItems = [];
        },
        torrentShow() {
            this.initTorrent()
            const input = document.getElementById("torrent");
            this.sourceItems = input.files;
            this.ifTorrent();
        },
        // 解析种子文件
        ifTorrent() {
            let formData = new FormData();
            var file = this.sourceItems[0];
            formData.append("torrentFile", file);
            var request = "parse";
            let torrentName = file.name;
            this.Utils.doTorrentRequest(request, formData).then(res => {
                this.torrentResultHandler(res, torrentName);
            }, err => {
                this.btnLoading = false;
                this.showBannel(err, "allBox")
            });
        },
        torrentResultHandler(res, name) {
            this.$refs.parseTipsDialog.parseTipsShow = false;
            if (res.status == 200) {
                this.$refs.subfileSelectDialog.initData(res.data);
                this.$refs.subfileSelectDialog.subfileShow = true;
            }
            if (res.status == 401) {
                this.showBannel(this.$t('language.exception.saltInvalid'), this.$refs.rightBo.id)
            }
            if (res.status == 400) {
                if (res.reason == "parseFail" || res.reason == "unsupportedTorrent") {
                    this.showBannel(this.$t('language.popup.remoteTaskPopup.parseFail'), this.$refs.rightBo.id)
                    this.saveFailedParse(cloudSite, name);
                }
            }
            // 清空磁力解析缓存
            this.$store.state.parseMagnet = null;
            this.$store.state.parseMagnetCloudSite = null;
        },
        // 记录解析失败的任务
        saveFailedParse(cloudSite, name) {
            let that = this;
            var requestData = new taskOfflineUtils.addParseFailedTask(commonUtils.getUser().id, 6, cloudSite, name);
            this.Utils.doTorrentRequest("parsefail", requestData).then(res => {
                let data = res.data;
                const task = {
                    "filesize": 0,
                    "result": data.state,
                    "name": data.name,
                    "id": data.id,
                    "toItem": data.toItem,
                    "type": data.type,
                    "url": data.url
                };
                task.toItem.id = data.toItem.fileId;
                task.toItem.name = data.toItem.filename;
            }, err => {
                this.btnLoading = false;
                if (this.$refs.parseTipsDialog) {
                    this.$refs.parseTipsDialog.parseTipsShow = false;
                }
                this.showBannel(err,"allBox");
            });
        },
        checkedOpen() {
            if(!this.checkedEmail&&!this.sendEmail){
                //如果当前未选择并且无邮箱
                this.openAddEmailNotice();
            }else{
                this.checkedEmail = !this.checkedEmail;
            }
        },
        openAddEmailNotice() {
            this.$refs.addEmialNoticeDialog.open(this.sendEmail);
        },
        //提交任务名
        submiTransfertName() {
            if(this.$refs.editInput.value.length>32){
                this.$refs.editInput.value =  this.$refs.editInput.oldNameValue;
                this.showBannel(this.$t('language.taskList.backupTaskNameRule'),"remoteTask");
                return false;
            }
            commonUtils.submiTaskName(this);
        },
        //打开选中云盘弹窗
        selectCloudOpen() {
            this.$refs.uploadToTreeDialog.uploadToShow = true;
        },
        //报错提示
        showBannel(reason, idValue) {
            this.$toast({
                text: reason,
                type: 'fail',
                idValue: idValue
            });
        },
        //移除当前选项
        removeItem(index) {
            console.log(this.sourceItems)
            if(this.sourceItems.length>1) {
                this.sourceItems.splice(index, 1);
            }else {
                this.sourceItems = [];
            }
            if(!this.sourceItems&&this.sourceItems.length<0) {
                this.initTorrent();
            }
        },
        removeAll() {
            this.sourceItems = [];
            this.initTorrent();
        },
        clearPageChoose() {
            this.remoteType = 0;
            this.inputValue = commonUtils.getTaskTxt(this);
            this.sourceItems = [];
            this.singleDrives = null;
            this.checkedEmail = false;
            this.sendEmail = "";
            this.torrentId = '';
            this.torrentType = '';
        },
    },
}
</script>

<style>
.transfer-right-body {
    width: 100%;
    height: calc(100% - 60px);
    /*no*/
    background-color: #f2f7fe !important;
    position: relative;
    top: 90Px;
    overflow-x: hidden;
}

/*定义滑块，内阴影及圆角*/
#tasktableBox tbody::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
}

#tasktableBox tbody::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}
#remoteTask .el-loading-spinner i {
    color: #999999;
}

#remoteTask .el-loading-spinner {
    font-size: 45px;
    /*no*/
}

#remoteTask .task-operating {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 100%;
    font-family: Microsoft YaHei;
    letter-spacing: 0em;
}

#remoteTask .task-operating .task-operating-name{
    font-size: 30px;/*no*/
    font-weight: 290;
    line-height: 30px;/*no*/
    text-align: center;
    color: #6F7886;
    margin-bottom: 10px;/*no*/
}

#remoteTask .task-operating .box-center-btn{
    font-size: 14px;/*no*/
    font-weight: normal;
    line-height: 14px;/*no*/
    color: #5562B4;
    padding: 14px 0;/*no*/
    margin-top: 20px;/*no*/
    box-sizing: border-box;
    border: 1px solid #B3BCF6;
    border-radius: 6px;/*no*/
    min-width: 160px;/*no*/
    height: 40px;/*no*/
    display: flex;
    align-items: center;
    justify-content: center;
}

#remoteTask .task-operating .box-center-btn div{
    margin-right: 8px;/*no*/
}

#remoteTask .task-operating-des {
    font-size: 14px;/*no*/
    font-weight: 290;
    line-height: 20px;/*no*/
    color: #6F7886;
    max-width: 345px;/*no*/
    margin-top: 25px;/*no*/
    position:unset;
}

#remoteTask .transfer-button {
    border-radius: 6px;/*no*/
    padding: 0 30px !important;/*no*/
    min-width: 180px;/*no*/
    display: flex;
    justify-content: center;
}

#remoteTask .task-box-middle {
    height: calc(75% + 20px);/*no*/
    background-position-x: 30px;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/remote_task.vue